import React, {useState} from 'react'
import i18n from 'i18next'
import Button from '#components/a/Button'
import FlyoutAnchor from '#components/m/Flyout/FlyoutAnchor'
import {FlyoutPivot} from '#components/m/Flyout/FlyoutPivot'
import {FlyoutPosition} from '#components/m/Flyout/FlyoutPosition'
import RessourcenDialog from './RessourcenDialog'
import {useAbteilungen} from '#hooks/store/useAbteilungen'

export function PlanRessourceButton() {
  const [showRessourcenDialog, setShowRessourcenDialog] = useState()
  const {abteilungen, isLoading} = useAbteilungen()

  const closeRessourcenDialog = () => {
    setShowRessourcenDialog(false)
  }

  const ressourcenDialogVisibilityChanged = visible => {
    setShowRessourcenDialog(visible)
  }

  return (
    <FlyoutAnchor
      flyoutPosition={FlyoutPosition.bottom}
      flyoutPivot={FlyoutPivot.end}
      openSync={showRessourcenDialog}
      flyoutVisibilityChanged={ressourcenDialogVisibilityChanged}
      flyoutDistance={15}
      flyoutContent={
        <RessourcenDialog onClose={closeRessourcenDialog} abteilungen={abteilungen} abteilungenLoading={isLoading} />
      }
      startWidth={320}
      startHeight={470}>
      <Button
        data-testid="plan-ressource"
        id="plan-ressource"
        text={i18n.t('ressourcenplanung_plan_ressource')}
        variant="primary"
      />
    </FlyoutAnchor>
  )
}

export default PlanRessourceButton
